import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import ContentManager from './components/ContentManager';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
    },
  },
});

const ContentBlocks = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ContentManager />
      <ReactQueryDevtools initialIsOpen={false} />
      <ToastContainer position="top-right" autoClose={4000} newestOnTop closeOnClick />
    </QueryClientProvider>
  );
};

export default ContentBlocks;
